import * as React from 'react';
import { useQueryParams } from '@lon/mathnation-suit/hooks';
import { useCheckPasswordRecoveryTokenQuery } from '@lon/mathnation-suit/requests';

export const useCheckToken = () => {
  const [params] = useQueryParams();

  const [errored, setErrored] = React.useState<null | 'general' | 'expired'>(
    null
  );

  const { data, loading } = useCheckPasswordRecoveryTokenQuery({
    variables: {
      id: params.token,
    },
    skip: !params.token || params?.['district-activation'] === 'true',
    onError: (err) => {
      const error500 = err.graphQLErrors?.find(
        (v) => v.extensions.code === 'NOT_TRUE_ERROR'
      );
      setErrored(error500 ? 'general' : 'expired');
    },
  });

  const isExpired = data?.passwordRecoveryToken?.expired;

  return { errored, isExpired, loading };
};
